import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "button"]
  static values = { url: String }

  async fill() {
    const form = this.element.closest("form")
    const title = form.querySelector("[name='book[title]']")?.value?.trim()
    const author = form.querySelector("[name='book[author]']")?.value?.trim()

    if (!title) {
      alert("Please enter a book title first.")
      return
    }

    const btn = this.buttonTarget
    const originalText = btn.textContent
    btn.textContent = "Generating..."
    btn.disabled = true

    try {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({ title, author })
      })

      const data = await response.json()

      if (response.ok) {
        this.textareaTarget.value = data.description
      } else {
        alert(data.error || "Failed to generate description.")
      }
    } catch (e) {
      alert("Request failed: " + e.message)
    } finally {
      btn.textContent = originalText
      btn.disabled = false
    }
  }
}
